// Module
var code = `<div ng-controller="SelectMultyAsyncCtrl" class="form-group {{form.htmlClass}} schema-form-select"
     ng-class="{
        'has-error': form.disableErrorState !== true && hasError(),
        'has-success': form.disableSuccessState !== true && hasSuccess(),
        'has-feedback': form.feedback !== false
        }"
>
    <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">
        {{form.title}}
    </label>
    <div class="{{form.fieldHtmlClass}}">
        <ui-select multiple
                   sf-field-model
                   spinner-enabled="true"
                   remove-selected="false"
                   limit="{{form.maxItems}}"
                   class="form-control"
        >
            <ui-select-match placeholder="{{form.placeholder}}">
                {{\$item.name}}
            </ui-select-match>

            <ui-select-choices refresh="updateTitleMap(\$select.search, form.service, form.method, \$select.ngModel.\$\$rawModelValue)"
                               refresh-delay="500"
                               repeat="item.value as item in title_map"
            >
                <div ng-bind-html="item.name"></div>
            </ui-select-choices>

            <ui-select-no-choice>
                Not found...
            </ui-select-no-choice>

        </ui-select>
    </div>
    <div class="help-block" sf-message="form.description"></div>
</div>
`;
// Exports
module.exports = code;